import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

export default function SideMenu() {
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const auth = JSON.parse(localStorage.getItem("auth") || "{}");
  const role = (auth.role || "").toLowerCase().trim();

  const ADMIN_MENU = [
    { label: "Orders", path: "/pos/orders" },
    { label: "Sales Persons", path: "/pos/sales-persons" },
    { label: "Barcode", path: "/pos/barcode" },
    { label: "QR Settings", path: "/pos/qr" },
    { label: "Profile", path: "/pos/profile" },
  ];

  const SALES_MENU = [
    { label: "Sell", path: "/pos/sell" },
    { label: "Orders", path: "/pos/orders" },
    { label: "Profile", path: "/pos/profile" },
  ];

  const MENU = role === "admin" ? ADMIN_MENU : SALES_MENU;

  const handleLogout = () => {
    setShowLogoutModal(true);
  };

  return (
    <>
      <nav className="p-4 space-y-2">
        {MENU.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `block px-3 py-2 rounded ${
                isActive
                  ? "bg-blue-100 text-blue-600"
                  : "hover:bg-gray-100"
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}

        <hr className="my-3" />

        <button
          onClick={handleLogout}
          className="w-full text-left px-3 py-2 rounded hover:bg-red-100 text-red-600 font-medium"
        >
          Logout
        </button>
      </nav>

      {/* Desktop Centered Modal */}
      {showLogoutModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          
          {/* Background Overlay */}
          <div
            className="absolute inset-0 bg-black/40"
            onClick={() => setShowLogoutModal(false)}
          />

          {/* Modal Card */}
          <div className="relative bg-white w-[360px] rounded-2xl shadow-2xl p-6 animate-fadeIn">
            
            <h2 className="text-lg font-semibold text-gray-800 mb-2 text-center">
              Logout
            </h2>

            <p className="text-sm text-gray-600 mb-6 text-center">
              Are you sure you want to logout?
            </p>

            <div className="flex justify-center gap-3">
              <button
                onClick={() => {
                  localStorage.removeItem("auth");
                  navigate("/pos/login", { replace: true });
                }}
                className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-lg font-medium transition"
              >
                Yes, Logout
              </button>

              <button
                onClick={() => setShowLogoutModal(false)}
                className="bg-gray-200 hover:bg-gray-300 px-5 py-2 rounded-lg font-medium"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}









// import { NavLink, useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// export default function SideMenu() {
//   const navigate = useNavigate();

//   const handleLogout = () => {
//   //toast.dismiss();

//   const id = toast.loading("Preparing logout...", {
//     position: "top-center",
//     autoClose: false,
//     closeButton: false,
//   });

//   setTimeout(() => {
//     toast.update(id, {
//       render: (
//         <div className="w-[260px]">
//           <p className="text-sm font-semibold text-gray-700 mb-4 text-center">
//             Are you sure you want to logout?
//           </p>

//           <div className="flex justify-center gap-3">
//             <button
//               onClick={() => {
//                 localStorage.removeItem("auth");
//                 toast.dismiss(id);
//                 navigate("/pos/login", { replace: true });
//               }}
//               className="bg-red-600 hover:bg-red-700 text-white px-4 py-1.5 rounded text-sm"
//             >
//               Yes, Logout
//             </button>

//             <button
//               onClick={() => toast.dismiss(id)}
//               className="bg-gray-200 hover:bg-gray-300 px-4 py-1.5 rounded text-sm"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       ),
//       type: "default",
//       isLoading: false,
//       autoClose: false,
//       closeButton: false,
//     });
//   }, 50); // important
// };


//   // ✅ SAME SOURCE as RoleRoute
//   const auth = JSON.parse(localStorage.getItem("auth") || "{}");
//   const role = (auth.role || "").toLowerCase().trim();

//   const ADMIN_MENU = [
//     { label: "Orders", path: "/pos/orders" },
//     { label: "Sales Persons", path: "/pos/sales-persons" },
//     { label: "Barcode", path: "/pos/barcode" },
//     { label: "QR Settings", path: "/pos/qr" },
//     { label: "Profile", path: "/pos/profile" },
//   ];

//   const SALES_MENU = [
//     { label: "Sell", path: "/pos/sell" },
//     { label: "Orders", path: "/pos/orders" },
//     { label: "Profile", path: "/pos/profile" },
//   ];

//   const MENU = role === "admin" ? ADMIN_MENU : SALES_MENU;

//   return (
//     <nav className="p-4 space-y-2">
//       {MENU.map((item) => (
//         <NavLink
//           key={item.path}
//           to={item.path}
//           className={({ isActive }) =>
//             `block px-3 py-2 rounded ${
//               isActive ? "bg-blue-100 text-blue-600" : "hover:bg-gray-100"
//             }`
//           }
//         >
//           {item.label}
//         </NavLink>
//       ))}

//       <hr className="my-3" />

//       <button
//         onClick={(e) => {
//           e.preventDefault();
//           e.stopPropagation();
//           handleLogout();
//         }}
//         className="w-full text-left px-3 py-2 rounded hover:bg-red-100 text-red-600 font-medium"
//       >
//         Logout
//       </button>
//     </nav>
//   );
// }
